import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'

export const Paragraph8 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={t('gameRules_title6')}
          anchor={[0.5, 0]}
          x={props.width / 2}
          style={tableTitleStyle}
        />
        <Text
          anchor={[0.5, 0]}
          x={props.width / 2}
          text={t('gameRules_title6_content_1')}
          style={paragraphStyle}
          y={100}
        />
        <Text
          x={60}
          y={150}
          text={t('gameRules_title6_content_2')}
          style={paragraphStyle}
        />
      </Container>
    )
  }
  , [])
  return content
}
